import { isObject } from '../../common/common.utils';
import { PEC_ERROR_MAP } from './errors.constants';
export const defaultErrorMessage = 'An unknown error occurred';
export const getErrorMessage = (error, defaultMessage = defaultErrorMessage) => {
    if (isObject(error)) {
        const apiErrorMessage = error?.response?.data?.error_details?.message;
        if (typeof apiErrorMessage === 'string') {
            return apiErrorMessage;
        }
        if (typeof error.message === 'string') {
            return error.message;
        }
    }
    if (typeof error === 'string') {
        return error;
    }
    return defaultMessage;
};
export const mapErrorMessage = (errorMessagesMap, error) => errorMessagesMap[getErrorMessage(error)] || errorMessagesMap.default;
export const getPECError = (error) => {
    if ('response' in error && error.response) {
        const axiosError = error;
        const responseData = axiosError.response?.data;
        let pecMessage;
        let pecDescription;
        let pecCode = responseData?.code ?? responseData?.error_details?.code;
        if (typeof responseData?.message === 'object' && responseData.message?.code) {
            pecCode = responseData.message.code;
        }
        if (pecCode && PEC_ERROR_MAP[pecCode]) {
            const pecError = PEC_ERROR_MAP[pecCode];
            return pecError;
        }
        // If we have a PEC code but it's not in our map, try to extract message and description from response
        if (pecCode) {
            pecMessage = responseData?.error_details?.error ?? 'Something went wrong';
            pecDescription = responseData?.error_details?.description;
            if (pecMessage && pecDescription) {
                return {
                    code: pecCode,
                    message: pecMessage,
                    description: pecDescription,
                };
            }
        }
    }
};
